import { Alert, Button, Popover, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../../shared/stores/RootStore";
import { useState } from "react";
import { DeleteIcon } from "../../../shared/views/icons";
import { CustomPopover } from "../../../shared/views/CustomPopover";
import { t } from "i18next";

const HlaWayDetailDeleteBase = () => {
  const { hlaStore } = useStores();
  const hlaWay = hlaStore.getSelected()!;

  const [deleting, setDeleting] = useState(false);

  return (
    <CustomPopover
      trigger={
        <Button
          colorPalette={"red"}
          fontSize={"sm"}
          size="sm"
          variant={"plain"}
        >
          <DeleteIcon /> Delete
        </Button>
      }
    >
      <Popover.Body>
        <Stack gap={4}>
          <Text textStyle={"label"}>Are you sure?</Text>

          {hlaStore.multiSelectedIds.size > 0 && (
            <Alert.Root status={"warning"}>
              <Alert.Indicator />
              <Alert.Description>
                {`${t(`shared:ways`, {
                  count: hlaStore.multiSelectedIds.size,
                })} selected`}
              </Alert.Description>
            </Alert.Root>
          )}
        </Stack>
      </Popover.Body>
      <Popover.Footer justifyContent={"end"}>
        <Button
          loading={deleting}
          colorPalette={"red"}
          fontSize={"sm"}
          size="sm"
          onClick={async () => {
            setDeleting(true);
            var idsToDelete = [hlaWay.id];
            if (hlaStore.multiSelectedIds.size) {
              idsToDelete = [...hlaStore.multiSelectedIds];
            }
            for (const id of idsToDelete) {
              hlaStore.delete(id).finally(() => setDeleting(false));
            }
            hlaStore.setMultiSelectedIds(new Set());
          }}
        >
          Delete
        </Button>
      </Popover.Footer>
    </CustomPopover>
  );
};

export const HlaWayDetailDelete = observer(HlaWayDetailDeleteBase);
